import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { scrollToElement } from '../../../common/scroll';

export default function AutoScroll() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('scroll_to')) {
      if (window.reactSuspenseIsLoading !== true) {
        scrollToElement(() => document?.getElementById(searchParams.get('scroll_to')), 5000);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [searchParams, pathname]);

  return null;
}
